var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmarks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/bookmarks_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18L21 19V3C21 1.9 20.1 1 19 1ZM15 7V19.97L10.79 18.16L10 17.82L9.21 18.16L5 19.97V7H15ZM5 5H15C16.1 5 17 5.9 17 7V23L10 20L3 23V7C3 5.9 3.9 5 5 5Z",
    fill: "#0071CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.5b27f1303bd03757ce5d50214277aa5e.svg";
export { ForwardRef as ReactComponent };